import { fetchConfigarationData } from "../helpers/utils/Utils";

 const appConfigData = await fetchConfigarationData(); 


export var AUTH_URL = "";
export var ENVIRONMENT = "";
export var IDM_SERVICE_URL = "";
export var CLIENT_ID = "";
export var APP_URL = "";
export var BUSINESS_CODE = "";
export var CLIENT_SECRET = "";
export var USER_SCOPE = "";
export var isDEV = false;
export var IS_PROTECTION_SDK_AVAILABLE = false;
export var REDIRECT_URL = ""
export var GOOGLE_PLACES_API_KEY = appConfigData.MAP_API_KEY;
export const OTP_USERS = '/api/v1/users/';
export const SAVINGS_CARD = 32;
export const SAVING_CARD_CODE = 32;
export const ISDEV_ENV = false;
export const SPENDING_ALERT = "SpendingAlert";
export const COVERED_BY_KUDZU = "CoveredByKudzu";
export const COVERED_BY_KUDZU_PLUS = "CoveredByKudzuPlus";
export const SAVINGS_HABIT = "SavingsHabit";
export const SAVINGS_GOALS = "SavingsGoal";
export const NOTIF_CARD_SERVICES = "CARD_SERVICES"
export const NOTIF_ACCOUNT_SERVICE = "ACCOUNT_SERVICES"
export const NOTIF_CUSTOMER_CARE = "CUSTOMER_CARE"
export const NOTIF_TRANSACTIONS = "TRANSACTIONS"
export const NOTIF_STATEMENTS = "STATEMENTS"
export const NOTIF_FEES = "Fees"
export const NOTIF_CONFIG_POLICY = "KudzuPrivacyPolicy"
export const NOTIF_CONFIG_SMS_SERVICE = "SMSTermsofService"
export const NOTIF_CONFIG_BANCORP = "BancorpPrivacyNotice"
export const NOTIF_MANAGE_SAVINGS_HABIT = "manage-savings-habits"
export const NOTIF_SPENDSENSE_ALERT = "spendsense-alerts"
export const NOTIF_SPENDSENSE_ALERT2 = "SPENDSENSE_ALERT"
export const NOTIF_COVERED_BY_KUDZU_TERMS = "covered-by-kudzu-terms"
export const NOTIF_COVERED_BY_KUDZU_OPT_IN = "covered-by-kudzu-opt-in"
export const NOTIF_PERSONAL_INFO = "personal_info"
export const NOTIF_PAYPERKS = "payperks"
export const NOTIF_MANAGE_DIRECT_DEPOSIT = "DDA"
export const cbk_transaction = "cbk_transaction"
export const Add_Money_PopOver = "kudzuplus-add-money"
export const Kudzu_Plus_Opt_In ="kudzuplus-opt-in"
export const MOBILE_UPDATE_IDOLOGY_VERIFY = "MOBILE_UPDATE_IDOLOGY_VERIFY"

export const ENROLL_STATUS_PEN = 'PEN'; //Pending
export const ENROLL_STATUS_APP = 'APP'; //Approved
export const ENROLL_STATUS_REV = 'REV'; //Review
export const ENROLL_STATUS_DEC = 'DEC'; //DECLINE
export const IDOLOGY_CAMEL_CASE = 'Idology'; //DECLINE

//https://maps.googleapis.com/maps/api/place/details/json?place_id={PLACE_ID}&key=" + GOOGLE_PLACES_API_KEY
export const CHECKING = 'Checking';
export const SAVINGS = 'Savings';
export const SPENDING = 'Spending';
export const STATUS_SUCCESS_CODE = 2000;
export const STATUS_SUCCESS_CODE_PDF_DOWNLOAD = 200;
export const INITIAL_DELAY = 90000; // 1.5 minutes
export const POLLING_INTERVAL = 15000; // 15 seconds
export const MAX_ATTEMPTS = 10;
export const LOGIN_TOKEN = "connect/token";
export const PREFERRED_IDENTITY_SERVICE_URL = "api/v1/ping";
// export const POST_REGISTER_FCM_TOKEN = "/api/cardholders/push-notifications/register";
export const POST_REGISTER_FCM_TOKEN = (isB2c) => isB2c ? "api/v1/cardholders/push-notifications/register" : "/api/cardholders/push-notifications/register" ;
export const POST_LOGIN = "api/cardholders/post-login?";
export const GENERATE_OTP = "api/cardholders/mobile/generate-otp";
export const TWO_AUTH_VERIFY_OTP = "api/cardholders/mobile/verify-otp";
export const SIGNUP_PHN_NEW_ACCOUNT = (isFromSmiOne, smiOneUserId) => isFromSmiOne ? `api/v1/cardholders/${smiOneUserId}/kudzu-experience-migration/phone-numbers` : '/api/v1/users/create-new-account';
export const PAID_PROMO_KEY = "10001";
export const TRAIL_PROMO_KEY = "10000";

//unviersity apis
export const STUDENT_SIGNUP_EMAIL_ACCOUNT = (userId) => `api/v1/users/${userId}/students/emails`;
export const STUDENT_SIGNUP_VERIFY_NEW_ACCOUNT = (userId, sessionId) => `api/v1/users/${userId}/students/emails/${sessionId}/verify`;
export const STUDENT_RESEND_EMAIL_CODE = (userId) => `api/v1/users/${userId}/students/emails/re-send`;



//
//  export const STUDENT_SIGNUP_UNIVERSITY_SELECTION = (searchText, rows,page) => `api/v1/masters/universities/searchText=${searchText}/rows=${rows}/page=${page}`;
//  export const STUDENT_SIGNUP_UNIVERSITY_SELECTION = (searchText, rows,page) => `api/v1/masters/universities/${searchText}/${rows}/${page}`;
  
export const STUDENT_SIGNUP_UNIVERSITY_SELECTION = (searchText, rows, page) => `api/v1/masters/universities/${searchText}/${rows}/${page}`;




export const SIGNUP_VERIFY_NEW_ACCOUNT = (userId, sessionId,  smiOneUserId, isFromSmiOne) => isFromSmiOne ? `api/v1/cardholders/${smiOneUserId}/kudzu-experience-migration/phone-numbers/${sessionId}/verify` : `api/v1/users/${userId}/phone-numbers/${sessionId}/verify`;
export const PHONE_OTP_GENERATION = ( smiOneUserId, isFromSmiOne) =>  `api/v1/cardholders/${smiOneUserId}/kudzu-experience-migration/phone-numbers/re-send`;
export const EMAIL_OTP_GENERATION = "/api/v1/users/";
export const SMI_ONE_EMAIL_OTP_GENERATION = (smiOneUserId) => `/api/v1/cardholders/${smiOneUserId}/kudzu-experience-migration/emails`;
export const EMAIL_OTP_GENERATION_NEW = (isB2c) => isB2c ?  "/api/v1.1/users/" : "/api/v1/users/";
export const SMI_ONE_EMAIL_OTP_VERIFY = (smiOneUserId, sessionId) => `api/v1/cardholders/${smiOneUserId}/kudzu-experience-migration/emails/${sessionId}/verify`;
export const SMI_ONE_EMAIL_OTP_RESEND = (smiOneUserId) => `api/v1/cardholders/${smiOneUserId}/kudzu-experience-migration/emails/re-send`;
export const SMI_ONE_CREATE_PASSWORD = (smiOneUserId) => `api/v1/cardholders/${smiOneUserId}/kudzu-experience-migration/validate`;
export const SMI_ONE_CARD_VALIDATE = (smiOneUserId, applicationId) => `api/v1/cardholders/${smiOneUserId}/kudzu-experience-migration/verify-smione-card?applicationId=${applicationId}`;
export const SMI_ONE_VALIDATE_SSN = (smiOneUserId, applicationId) =>  `api/v1/cardholders/${smiOneUserId}/kudzu-experience-migration/validate-ssn?applicationId=${applicationId}`;
export const SMI_ONE_PERSONAL_INFO_SUBMIT = (smiOneUserId) =>  `api/v1/cardholders/${smiOneUserId}/kudzu-experience-migration/registration`;
export const GENERATE_OTP_FORGOT_PASSWORD = "api/v1/users/generate-otp/forgot-password"
export const RESEND_OTP = (userid) => `api/v1/users/${userid}/phone-numbers/re-send/forgot-password`;
export const VERIFY_OTP = (userid, sessionid) => `api/v1/users/${userid}/sessions/${sessionid}/verify/forgot-password`;
export const UPDATE_PASSWORD = (userid, sessionId) => `api/v1/users/${userid}/sessions/${sessionId}/update-password`;
export const META_DATA_POLICIES = '/api/masters/registration/metadata/v3?';
export const GOOGLE_PLACES_AUTO_COMPLETE = (TEXT) => `/maps/api/place/autocomplete/json?input=${TEXT}&key=${GOOGLE_PLACES_API_KEY}&language=en&components=country:us`;
export const GOOGLE_PLACE_DETAILS_WITH_PLACE_ID = (PLACE_ID) => `/maps/api/place/details/json?place_id=${PLACE_ID}&key=${GOOGLE_PLACES_API_KEY}`;
export const PRIVACY_POLICY = (userId, applicationId) => `/api/v1/users/${userId}/programs/content?contentType=PrivacyPolicyV2&language=en&applicationId=${applicationId}&accountType=0`;
export const USER_AGGREMENT = (userId, applicationId) => `/api/v1/users/${userId}/programs/content?contentType=TnC&language=en&applicationId=${applicationId}@ist&accountType=0`;
export const DEPOSIT_AGGREMENT = (userId,contentType ,applicationId) => `/api/v1/users/${userId}/programs/content?contentType=${contentType}&language=en&applicationId=${applicationId}@ist&accountType=0`;
export const SAVINGS_AGGREMENT = (userId, contentType,applicationId) => `/api/v1/users/${userId}/programs/content?contentType=${contentType}&language=en&applicationId=${applicationId}@ist&accountType=32`;
export const ELECTRONIC_AGGREMENT = (userId, applicationId) => `/api/v1/users/${userId}/programs/content?contentType=ESign&language=en&applicationId=${applicationId}&accountType=0`;
export const ELECTRONIC_AGGREMENT_SMI =`/api/masters/program-content?programKey=200&contentType=ESign&language=en&accountType=64`;
export const BANCORP_POLICY_SMI =`/api/masters/program-content?programKey=200&contentType=PrivacyPolicyV2&language=en&accountType=64`;
export const DEPOSIT_AGGREMENT_SMI = `/api/masters/program-content?programKey=200&contentType=DepositTerms&language=en&accountType=64`;
export const SAVINGS_AGGREMENT_SMI = `/api/masters/program-content?programKey=200&contentType=TnC&language=en&accountType=32`;

// export const VALIDATE_ALL_DETAILS_OF_USER = (userId) => `/api/v1/users/${userId}/user-info/validate`;
export const VALIDATE_ALL_DETAILS_OF_USER = (userId,isB2c) => isB2c ? `/api/v1.1/users/${userId}/user-info/validate` : `/api/v1/users/${userId}/user-info/validate`;

// export const REGISTER_USER = (userId) => `/api/v1/users/${userId}/registration`;
export const REGISTER_USER = (userId,isB2c) =>isB2c ? `/api/v1.1/users/${userId}/registration` : `/api/v1/users/${userId}/registration`;

export const PROGRAM_CONTENT = "/api/masters/program-content"
export const SIGN_UP_FEATURE = "/api/v1/users/feature"
export const SIGN_UP_KUDZUPLUS_CHECK = "api/v1/users/signup"
export const VERIFY_ACCESS_CODE = "/api/v1/users/signup/access-code"
export const CAN_CREATE_SAVINGS_ACC = (cardkey) => `api/cardholders/cards/${cardkey}/savings/cancreate`


////CONATCT US
export const GET_ESIGN_STATUS = (cardKey) => `/api/cardholders/policy/latest?CardKey=${cardKey}&contentType=Esign`;
export const GET_ESIGN_AGREEMENT = (cardKey) => `/api/cardholders/policy/pending-to-accept?CardKey=${cardKey}&contentType=Esign`;
export const ACCEPT_E_SIGN_AGGREMENT = (cardKey) => `/api/cardholders/policy/opt-out?CardKey=${cardKey}`;
export const CREATE_TICKET = (cardKey) => `/api/cardholders/${cardKey}/create/ticket`;


///profile get info
export const GET_USER_PORFIE_INFO = (cardKey) => `/api/cardholders/profile?CardKey=${cardKey}`;


//var finalUrl = GET_COMPLETED_AND_PENDING_TRANSACTIONS + "minAmount=" + minAmount + "&maxAmount=" + max_amount + "&debits=" + showSpends + "&credits=" + showLoads + '&fromDate=' + fromDate + '&toDate=' + toDate + '&cardKey=' + cardKey + '&rowsPerPage=10' + '&page=' + currentPage + '&statusCode=STL,APP'

export const TRANSACTIONS = (cardkey, debits, credits, minAmount, maxAmount, fromDate, toDate, rowsPerPage, page, SearchV) => `/api/cardholders/transactions/v2/?cardKey=${cardkey}&debits=${debits}&credits=${credits}&minAmount=${minAmount}&maxAmount=${maxAmount}&fromDate=${fromDate}&toDate=${toDate}&rowsPerPage=${rowsPerPage}&page=${page}&statusCode=STL,APP&search=${SearchV}`;
export const UPCOMINGTRANSACTIONS = (cardkey, debits, credits, minAmount, maxAmount, rowsPerPage, page, SearchV) => `/api/cardholders/upcoming/transactions/?cardKey=${cardkey}&debits=${debits}&credits=${credits}&minAmount=${minAmount}&maxAmount=${maxAmount}&rowsPerPage=${rowsPerPage}&page=${page}&statusCode=STL,APP&search=${SearchV}`;
export const GETTRANSACTIONDETAILS = (cardkey, transactionId) => `api/cardholders/upcoming/transaction/${transactionId}/details?cardKey=${cardkey}`;
export const GET_DDA_DETAILS = '/api/cardholders/dda?cardKey=';
export const GET_DDA_DETAILS_NEW =(cardKey) => `/api/cardholders/dda?cardKey=${cardKey}`
export const GET_DDA_DOWNLOAD_URL = '/api/cardholders/dda/pdf?CardKey=';
export const GET_RELOAD_DETAILS = 'api/v2/reload-cash';
export const GET_NOTIFICATIONS = (cardKey, isRead, isUnread, rowsPerPage, page, includeAll) => `/api/cardholders/alerts/v2?CardKey=${cardKey}&read=${isRead}&unread=${isUnread}&rowsPerPage=${rowsPerPage}&page=${page}&includeAll=${includeAll}`;
export const NOTIFICATION_READ_ALERTS = "/api/cardholders/alerts/read";
export const NOTIFICATION_UNREAD_ALERTS = "/api/cardholders/alerts/unread";
export const NOTIFICATION_UNREAD_READ_ALERTS = (cardKey, isReadAll, includeAll) => `/api/cardholders/alerts/${cardKey}/${isReadAll}?includeAll=${includeAll}`;
export const GET_NOTIFICATION_SETTINGS = (cardKey) => `/api/cardholders/notifications?cardKey=${cardKey}`;
export const UPDATE_NOTIFICATION_SETTINGS = (cardKey) => `/api/v1/cardholders/notifications?cardKey=${cardKey}`;
export const GET_RECCURING_TRANSACTIONS = (cardKey, rowsPerPage, page, statusCode) => `/api/cardholders/recurring/transactions/merchant/${cardKey}/${rowsPerPage}/${page}/${statusCode}`;
export const RESTORE_RECURRING_PAYMENTS = (transactionId, cardKey) => `/api/cardholders/upcoming/transaction/${transactionId}/restore/${cardKey}`;
export const RESTORE_RECCURRING_PAYMENTS_UPDATED = (transactionId, cardKey) => `api/cardholders/recurring/transactions/${transactionId}/restore/${cardKey}`;
export const GET_RECURRING_TRANSACTIONS_DETAILS = (transactionId, cardKey) => `api/cardholders/recurring/transaction/${transactionId}/details/${cardKey}`
export const UPDATE_CARDNAME = "/api/cardholders/cards/update-nickname/";
export const GET_USED_AMOUNT_DETAILS = "api/cardholders/spendamount?cardKey="
export const MERCHANT_RECURRING_STOP ="api/cardholders/recurring/transactions/merchant/stop"
//ACHA
export const GET_ACCOUNT_TYPES = "/api/v1/users/cards/{cardKey}/accountTypes"
export const ADD_ACH_ACCOUNT = "/api/v1/users/addACHAccount"
export const GENERATE_OTP_ADD_ACH_ACCOUNT = '/api/v1/users/cards/{CARDKEY}/generate-otp/add-achAccount'
export const VERIFY_OTP_ADD_ACH_ACCOUNT = '/api/v1/users/verify/add-achAccount'
export const RESEND_OTP_ADD_ACH_ACCOUNT = '/api/v1/users/cards/{CARDKEY}/re-send/add-achAccount'
export const GET_ACCOUNTS_FOR_TRANSFER = '/api/v1/users/cards/{CARD_KEY}/accounts'
export const TRANSFER_FUNDS = "/api/v1/users/cards/{CARD_KEY}/accounts/transfer-funds"
export const GET_HOLIDAYS = "/api/v1/masters/holidays"
export const CANCEL_TRANSFER = "/api/v1/users/cards/{CARD_KEY}/transactions/cancel"
export const VERIFY_EXTERNAL_ACCOUNT = "/api/v1/users/cards/{cardKey}/accounts/verify"
export const REMOVE_EXTERNAL_ACCOUNT = "/api/v1/users/remove-ACHAccount"
export const GENERATE_EXISTING_PHONE_EMAIL_OTP = "/api/v1/users/phonenumbers/generate-otp"
export const VERIFY_OTP_EXISTING_PHONE_EMAIL_NUMBER = "/api/v1/users/phoneNumbers/verify-otp"
export const RESEND_EXISTING_PHONE_EMAIL_NUMBER = "/api/v1/users/phonenumbers/re-send"
export const GET_FREQUENCIES = "/api/cardholders/cards/{CARD_KEY}/frequencies"
export const TINK_LINK_ENABLED_CHECK = "/api/cardholders/cards/tink"



//utilities
export const LOCK_CARD_API = "/api/cardholders/cards/suspend";  // lock api
export const UNLOCK_CARD_API = "/api/v1/users/cards/verify/unsuspend";  // unlock api
//Replace Card
export const GET_SHIPPING_ID = '/api/masters/programs/shipping-types?cardKey='; //  to get customer support number
export const REPORT_LOST_CARD_API = "/api/cardholders/cards/lost-stolen/v2";
export const REPLACE_CARD_API = "/api/cardholders/cards/replace/v2";
export const GET_ADD_NEW_CARD_METADATA = '/api/cardholders/secondary-cards/new/metadata?'; // to get address details for cardholder
//Change PIN
export const GENERATE_OTP_CHANGE_PIN = "/api/v1/users/generate-otp/change-pin";
export const VERIFY_CHANGE_PIN = "/api/v1/users/verify/change-pin";
export const RESENT_OTP_CHANGE_PIN = "/api/v1/users/phone-numbers/re-send/change-pin";
export const GET_PIN_CHANGE_DETAILS = "/api/cardholders/cards/change-pin";
//View Card
export const GENERATE_OTP_VIEW_CARD = "/api/v1/users/generate-otp/card-details";
export const RESEND_OTP_VIEW_CARD = "/api/v1/users/phone-numbers/re-send/card-details";
export const VERIFY_OTP_VIEW_CARD = "/api/v1/users/verify/card-details"
export const GET_CARD_DESIGN = '/api/cardholders/cards/designs?ids=';
//Activate Card
export const RESEND_ACTIVATE_CARD_OTP = "/api/v1/users/phone-numbers/re-send/activate-card"
export const GENERATE_ACTIVATE_CARD_OTP = "/api/v1/users/generate-otp/activate-card"
export const ACTIVATE_CARD_INLIFE = "/api/cardholders/cards/activate-inlife/v4"
export const VERIFY_OTP_ACTIVATE_CARD = '/api/v1/users/verify/activate-card'

//Unlock/UnSuspend Card
export const RESEND_UNLOCK_CARD_OTP = "/api/v1/users/cards/{cardKey}/re-send/unsuspend"
export const GENERATE_UNLOCK_CARD_OTP = "/api/v1/users/cards/{cardKey}/generate-otp/unsuspend"
export const VERIFY_OTP_UNLOCK_CARD = '/api/v1/users/cards/verify/unsuspend'


// export const GET_NOTIFICATION_SETTINGS = "/api/cardholders/notifications?";

//user profile
export const GET_USER_PROFILE_V2 = "/api/cardholders/profile/v2?";
export const GET_USER_PROFILE_LANGUGAGE_LIST = '/api/cardholders/masters/languages?'
export const GET_USER_PROFILE_TIMEZONE_LIST = '/api/cardholders/masters/time-zones?'


// export const UPDATE_PREFERRED_NAME =(cardKey) => `api/cardholders/cards/${cardKey}/update-preferredname`
export const UPDATE_PREFERRED_NAME =(cardKey, isB2c) => isB2c ?  `api/v1/cardholders/cards/${cardKey}/update-preferredname` : `api/cardholders/cards/${cardKey}/update-preferredname`
export const UPDATE_PHONE_NUMBER = "/api/v1/users/generate-otp/mobile-update"
export const RESEND_UPDATE_PHONE_NUMBER = "/api/v1/users/re-send/mobile-update"

// export const VERIFY_OTP_UPDATE_PHONE_NUMBER = "/api/v1/users/verify-otp/mobile-update"
export const VERIFY_OTP_UPDATE_PHONE_NUMBER = (isB2c) =>isB2c ? "/api/v1.1/users/verify-otp/mobile-update" : "/api/v1/users/verify-otp/mobile-update";

export const GENERATE_UPDATE_EMAIL_OTP = "/api/v1/users/generate-otp/email-update"
export const RESEND_UPDATE_EMAIL_OTP = "/api/v1/users/re-send/email-update"

// export const VERIFY_UPDATE_EMAIL_OTP = "/api/v1/users/verify-otp/email-update"
export const VERIFY_UPDATE_EMAIL_OTP = (isB2c) =>isB2c ? "/api/v1.1/users/verify-otp/email-update" : "/api/v1/users/verify-otp/email-update" 

export const GENERATE_UPDATE_ADDRESS_OTP = "/api/v1/users/generate-otp/address-update"
export const RESEND_UPDATE_ADDRESS_OTP = "/api/v1/users/re-send/address-update"
// export const VERIFY_UPDATE_ADDRESS_OTP =  "/api/v1/users/verify-otp/address-update"
export const VERIFY_UPDATE_ADDRESS_OTP = "/api/v1/users/address-update"
export const POST_UPDATE_USER_PROFILE = '/api/cardholders/profile/update?'

export const AGREEMENTS = "/api/cardholders/policy/latest?CardKey={cardKey}&contentType={contentType}";
export const SAVINGS_AGREEMENT_POSTLOGIN = "/api/masters/program-content?programKey=200&accountType=32&contentType={contentType}&lang=en"
//statements
export const DOWNLOAD_STATEMENT_OF_SELECTED_MONTH = '/api/cardholders/statements/download?';
export const GET_STATEMENTS_SELECTIONS = '/api/cardholders/statements/selections?cardKey=';
//fees
export const GET_FEES_SCHEDULE = "/api/masters/program/fee-details?CardKey=";
export const GET_FEES_META_CONTENT = (cardKey) => `/api/cardholders/policy/latest?CardKey=${cardKey}&contentType=FeeLHSMaster`
//trusted device
export const GET_TRUSTED_DEVICES = "/api/cardholders/devices";
export const UNTRUSTED_DEVICES = "/api/cardholders/devices/{deviceId}/untrust"
//change password 
export const GENERATE_OTP_CHANGE_PASSWORD = "/api/v1/users/cards/{CARD_KEY}/generate-otp/change-password"
export const VERIFY_OTP_CHANGE_PASSWORD = "/api/v1/users/verify/change-password";
// export const CHANGE_PASSWORD = "/api/v1/users/change-password";
export const CHANGE_PASSWORD = (isB2c) => isB2c ? "/api/v1.1/users/change-password" : "/api/v1/users/change-password"; 

export const RESEND_CHANGE_PASSWORD_TOP = "/api/v1/users/cards/{cardKey}/re-send/change-password";
//payperks 
export const GET_PAY_PERKS_API = (cardKey) => `/api/cardholders/payperks/details?cardKey=${cardKey}`;
export const GET_PAYPERKS_DASHBOARD = (cardKey) => `/api/cardholders/payperks/dashboard?cardKey=${cardKey}`;
///atm locations
export const ATM_LOCATIONS = (cardKey, lang) => `/api/atm-locations/v2/?cardKey=${cardKey}&language=${lang}`;

//Beneficiaries
export const GET_BENEFICIARIES = "/api/cardholders/cards/{cardKey}/beneficiaries"
export const GET_BENEFICIARY_DETAILS = "/api/cardholders/cards/{cardKey}/beneficiaries/{beneficiaryKey}/details"
export const ADD_BENEFICIARY = "/api/cardholders/cards/{cardKey}/add-beneficiary"
export const UPDATE_BENEFICIARY = "/api/cardholders/cards/{cardKey}/beneficiaries/{beneficiaryKey}/update"
export const REMOVE_BENEFICIARY = "/api/cardholders/cards/{cardKey}/beneficiaries/{beneficiaryKey}/remove"

export const ACCEPT_E_SIGN_AGREEMENT = "api/cardholders/policy/accept?"
export const GET_PENDING_PRIVACY_POLICY = "api/cardholders/policy/pending-to-accept?";

export const VALIDATE_AUTH_USER = "/api/cardholders/cards/{CARD_KEY}/validate-user"
export const GENERATE_OTP_ADD_AUTH_USER = '/api/v1/users/cards/{CARD_KEY}/generate-otp/add-authorizeUser'
export const RESEND_OTP_ADD_AUTH_USER = '/api/v1/users/cards/{CARD_KEY}/re-send/add-authorizeUser'
export const VERIFY_OTP_ADD_AUTH_USER = '/api/v1/users/verify/add-authorizeUser'
export const ADD_AUTH_USER = "/api/cardholders/cards/{CARD_KEY}/add-authorizeuser"
export const GET_AUTH_USERS = "/api/cardholders/cards/{CARD_KEY}/authorized-users"
export const RESEND_INVITE_LINK_AUTH_USER = "/api/cardholders/cards/{CARD_KEY}/authorized-user/resend-link"
export const VALIDATE_INVITE_CODE = "/api/cardholders/validate-inviteCode";

//climb

//export const GET_CLIMB_FEATURES  = (cardKey) => `/api/cardholders/cards/cardKey=${cardKey}/climb/features`;
export const GET_CLIMB_FEATURES = "/api/cardholders/cards/{CARD_KEY}/climb/features"
export const POST_PIN_CHANGE = "/api/cardholder/card/pinchange/commit?";

export const ADD_SAVINGS_HABIT = "/api/cardholders/cards/{CARD_KEY}/savings-habit/add";
export const GET_ALL_SAVINGS_HABIT = "/api/cardholders/cards/{CARD_KEY}/savings-habits";
export const OPT_IN_FEATURE = "/api/cardholders/cards/{CARD_KEY}/climb/{featureType}/opt-in";
export const OPT_OUT_FEATURE = "/api/cardholders/cards/{CARD_KEY}/climb/{featureType}/opt-out";
export const CLIMB_OPT_IN_OUT = "/api/cardholders/cards/{CARD_KEY}/climb/";
export const UPDATE_SAVINGS_HABIT = "/api/cardholders/cards/{CARD_KEY}/savings-habits/{habitId}/update";
export const GET_SAVINGS_HABIT_DETAILS = "/api/cardholders/cards/{CARD_KEY}/savings-habits/{habitId}/details";
export const REMOVE_SAVINGS_HABIT = "/api/cardholders/cards/{CARD_KEY}/savings-habits/{habitId}/remove";


export const GET_DETAILS_FRAUD_ALERT = "api/cardholders/transactions/high-risk/{code}";
export const POST_DETAILS_FRAUD_ALERT = "api/cardholders/transactions/high-risk/identify";
///spend cards
export const ADD_SPENDING_ALERT = (cardKey) => `/api/cardholders/cards/${cardKey}/spending-alerts/add`;
export const GET_ALL_SPEND_ALERTS = (cardKey) => `/api/cardholders/cards/${cardKey}/spending-alerts`;
export const GET_SPEND_ALERT_DETAILS = "/api/cardholders/cards/{CARD_KEY}/spending-alerts/{spendId}/details";
export const UPDATE_SPEND_ALERT = "/api/cardholders/cards/{CARD_KEY}/spending-alerts/{spendId}/update";
export const REMOVE_SPEND_ALERT = "/api/cardholders/cards/{CARD_KEY}/spending-alerts/{spendId}/remove";




// kyc/cip
export const GET_KYC_CIP_ACCESS = "api/cardholders/cip/access"
export const GENERATE_OTP_KYC_CIP = "/api/cardholders/enroll/cip/verify/generate-otp"
export const VERIFY_OTP_KYC_CIP = "/api/cardholders/enroll/cip/verify-otp"

//download transaction history
export const DOWNLOAD_TRANSACTION_HISTORY = "api/cardholders/download/document"


export const GET_CARDHOLDER_CARDS = '/api/cardholders/cards/true/true';
// export const END_SESSION = (BASEURL, CLIENT_ID, TOKEN, LOGOUT_REDIDRECT) => `${BASEURL}connect/endsession?client_id_hint=${CLIENT_ID}&token_hint=${TOKEN}&post_logout_redirect_uri=${LOGOUT_REDIDRECT}`;

export const END_SESSION = (isB2c,BASEURL,B2C_END_SESSION_URL, CLIENT_ID, TOKEN, LOGOUT_REDIDRECT) => isB2c ? `${B2C_END_SESSION_URL}post_logout_redirect_uri=${LOGOUT_REDIDRECT}` : `${BASEURL}connect/endsession?client_id_hint=${CLIENT_ID}&token_hint=${TOKEN}&post_logout_redirect_uri=${LOGOUT_REDIDRECT}` ;
export const GET_ACTIVITY_PRIVACY_POLICY = 'api/cardholders/policy/latest/';

// export const PAYPERKS_URL="https://payperksb-uat.kudzumoney.com/en/kd/website/dashboard?jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNjk2NjYyNjMxLCJpYXQiOjE2OTY1NzYyMzEsImp0aSI6ImIyMTI5YTVjNWIzNDRhMmI4ZmEwNjM5NDcxZTk1MjMwIiwidXNlcl9pZCI6MTEsInNlc3Npb25faWQiOiIzMjkiLCJzZXNzaW9uX2tleSI6IjExQDE2OTY1NzYyMzEiLCJ1c2VybmFtZSI6ImEyYmRjOTk4LTNmYWMtNDlkMS04ZTI5LTQyZDNmMTk0NTA3YSIsImp3dF9zZWNyZXQiOiI5OWE1N2JhYi1iZDdiLTRiNWQtYjRjZS0wZjdjYmE4MmFhZjAiLCJzaXRlX2lkZW50aWZpZXIiOiJrZCJ9.vmuXX3ACVLPcvhaiTjGgI9qx6iSVH_nich_JuuTJyBY&is_dark_mode=True"
export const APPLE_STORE_URL = "https://apps.apple.com/us/app/kudzu-money/id6449820905"
export const ANDROID_STORE_URL = "https://play.google.com/store/apps/details?id=com.kudzumoneyllc.kudzu"
export const CONTACT_US_URL = "https://www.kudzumoney.com/contact-us"

//Savings validate ssn
export const SAVINGS_VALIDATE_SSN = "/api/cardholders/cards/{cardkey}/validate-ssn"
export const CREATE_SAVINGS_ACCOUNT = "/api/cardholders/create-savings?cardKey={cardkey}"

//cancel upcoming transactions
export const CANCEL_UPCOMING_TRANSACTION = (transactionId, cardKey, all) => `/api/cardholders/upcoming/transaction/${transactionId}/cancel/${cardKey}/${all}`
export const CANCEL_ALL_UPCOMING_TRANSACTIONS = "/api/cardholders/upcoming/transaction/{transactionId}/cancel"
//connect school
export const GET_STUDENT_UNIVERSITY = (cardKey) => `api/cardholders/${cardKey}/university`;
export const STUDENT_EMAIL_UNIVERSITY = "api/v1/users/connect-school/generate-otp";
export const STUDENT_UNIVERSITY_UPDATE = (cardKey) => `api/cardholders/${cardKey}/university`;
export const STUDENT_VERIFY_ACESSCODE = "api/v1/users/connect-school/verify";
export const STUDENT_RESENDVERIFY_ACESSCODE = "api/v1/users/connect-school/re-send";


//upgrade to kudzuplus
export const GENERATE_UPGRADE_PLUS_OTP = "api/v1/users/cards/{cardKey=0}/generate-otp/kudzuplus-upgrade"
export const RESEND_UPGRADE_PLUS_OTP =  "api/v1/users/cards/{cardKey=0}/re-send/kudzuplus-upgrade"
export const VERIFY_UPGRADE_PLUS_OTP = "api/v1/users/verify/kudzuplus-upgrade"
export const UPGRADE_TO_KDUZU_PLUS = "api/v1/users/cards/{cardKey=0}/kudzuplus-upgrade"

//downgrade to kudzuplus
export const GENERATE_DOWNGRADE_PLUS_OTP = "api/v1/users/cards/{cardKey=0}/generate-otp/kudzuplus-downgrade"
export const RESEND_DOWNGRADE_PLUS_OTP = "api/v1/users/cards/{cardKey=0}/re-send/kudzuplus-downgrade"
export const VERIFY_DOWNGRADE_OTP = "api/v1/users/verify/kudzuplus-downgrade"   
export const DOWNGRADE_TO_KDUZU_PLUS = "api/v1/users/cards/{cardKey=0}/kudzuplus-downgrade"




//Cip staus
export const UPDATE_CIP_STATUS = (userId) =>  `api/v1/users/${userId}/cip-status`;
export const GET_CIP_STATUS = "api/cardholders/cip-status";


//Idology Apis
export const IDOLOGY_STATUS = (userid,type) =>  userid ? `api/v1/users/${userid}/idology/${type}`: `api/v1/users/idology/${type}`;
export const IDOLOGY_STATUS_SMIONE = (userid,type) => userid ? `/api/v1/cardholders/${userid}/kudzu-experience-migration/idology/${type}` :`api/v1/users/idology/${type}`;
export const IDOLOGY_VALIDATE_QUESTIONS = (userid) =>  userid ? `api/v1/users/${userid}/idology/kba` : `api/v1/users/idology/kba`;
export const IDOLOGY_VALIDATE_QUESTIONS_SMIONE = (userid) => userid ?  `/api/v1/cardholders/${userid}/kudzu-experience-migration/idology/kba` : `api/v1/users/idology/kba`;
export const IDOLOGY_ACCOUNT_STATUS_CHECK = (userid, id) => userid ? `api/v1/users/${userid}/account-status?id=${id}` : `api/v1/users/account-status?id=${id}`;


//Idology For Mobile Update

export const IDOLOGY_STATUS_FOR_MOBILE = (type) =>  `api/v1/users/idology/${type}`;
export const IDOLOGY_STATUS_SMIONE_FOR_MOBILE = (type) => `api/v1/users/idology/${type}`;
export const IDOLOGY_VALIDATE_QUESTIONS_FOR_MOBILE = `api/v1/users/idology/kba`;
export const IDOLOGY_VALIDATE_QUESTIONS_SMIONE__FOR_MOBILE = `api/v1/users/idology/kba`;
export const IDOLOGY_ACCOUNT_STATUS_CHECK_FOR_MOBILE = (id) =>  `api/v1/users/account-status?id=${id}`;
export const IDOLOGY_BANNER_API = (cardKey) => `api/cardholders/mobile/pending-update?cardKey=${cardKey}`
export const IDOLOGY_CHECK_MOBILE_PENDING =(cardKey, mobile)=> `api/cardholders/mobile/pending?cardKey=${cardKey}&mobile=${mobile}`

//feedback Reasons
export const FEEDBACK_REASONS = "api/v1/masters/kudzuplus-downgrade/reasons";
export const FEEDBACK_SUBMIT = "api/v1/users/kudzuplus-downgrade/feedback";
export const GET_ALLOCATE_FUND_FREQUENCIES = "api/v1/savings-goals/frequencies";
export const GET_ALLOCATE_FUND_ACCOUNTNAME = (cardKey) => `api/v1/cardholders/cards/${cardKey}/savings-goals/accounts?statusCode=ACT&isLocked=false`;
export const ADD_SAVING_GOALS = (cardKey) => `api/v1/cardholders/cards/${cardKey}/savings-goals`;
export const SAVING_ALLOCATE_FUND = (cardKey, goalKeyData) =>  `api/v1/cardholders/cards/${cardKey}/savings-goals/${goalKeyData}/allocate-funds`
export const ADD_SAVING_GOALS_V2 =(cardKey) => `api/v2/cardholders/cards/${cardKey}/savings-goals` 
export const EDIT_MANAGE_SAVIGN_V2 = (CARD_KEY, goalkey) => `api/v2/cardholders/cards/${CARD_KEY}/savings-goals/${goalkey}`       
export const SAVING_ALLOCATE_FUND_V2 = (cardKey, goalKeyData) =>  `api/v2/cardholders/cards/${cardKey}/savings-goals/${goalKeyData}/allocate-funds`
export const GET_SAVING_GOAL_DETAILS=(cardKey, goalKey) => `api/v1/cardholders/cards/${cardKey}/savings-goals/${goalKey}`

//manage covered by kudzu
export const GET_REPAID_TRANSACTIONS = (CARD_KEY,PAGE_NO) => `api/cardholders/cards/${CARD_KEY}/repaid-transactions?page=${PAGE_NO}&rowsPerPage=10`
export const GET_KUDZUPLUS_COVERAGE = (CARD_KEY) => `api/cardholders/cards/${CARD_KEY}/kudzu-plus-coverage`      
export const GET_MANAGE_SAVING_GOAL = (CARD_KEY, page) => `api/v1/cardholders/cards/${CARD_KEY}/savings-goals/${page}?pageSize=10&status=ACT`
export const GET_MANAGE_SAVING_GOAL_V2 = (CARD_KEY, page) => `api/v2/cardholders/cards/${CARD_KEY}/savings-goals/${page}?pageSize=10&status=ACT` 
export const GET_COMPLETE_SAVING_GOAL_V2 = (CARD_KEY, page) => `api/v2/cardholders/cards/${CARD_KEY}/savings-goals/${page}?pageSize=10&status=CMP`      
export const EDIT_MANAGE_SAVIGN = (CARD_KEY, goalkey) => `api/v1/cardholders/cards/${CARD_KEY}/savings-goals/${goalkey}`      
export const REMOVESAVINGGOAL = (CARD_KEY, goalkey) => `api/v1/cardholders/cards/${CARD_KEY}/savings-goals/${goalkey}/delete`      
export const SAVINGS_GOALS_BALANCE = "/api/v1/cardholders/cards/{cardkey}/savings-goals/balance";   
export const SMI_ONE_INITIATE_SESSION = (applicationId) => `api/v1/cardholders/kudzu-experience-migration/initiate-session?applicationID=${applicationId}`;   
// export const SPEND_AND_LOAD_GET = (cardKey, formattedFromDate, toDate ) => `api/cardholders/spends-loads/monthly/v2?cardKey=${cardKey}&fromDate=${formattedFromDate}&toDate=${toDate}`;   
// export const SPEND_AND_LOAD_GET = (cardKey, formattedFromDate, toDate , selectedType) => `api/cardholders/spends-loads/v2?cardKey=${cardKey}&fromDate=${formattedFromDate}&toDate=${toDate}?type=${selectedType}`;   
export const SPEND_AND_LOAD_GET = (cardKey, formattedFromDate, toDate , selectedType) => `api/cardholders/spends-loads/v2/${selectedType}/${cardKey}/${formattedFromDate}/${toDate}`;   
export const GET_BALANACE_ALLOCATE = (CARD_KEY) => `api/cardholders/balance?cardKey=${CARD_KEY}` 
export const SAVING_GAOLS_TRANSACTIONS = (cardkey, fromDate, toDate, rowsPerPage, page, SearchV) => `/api/v1/cardholders/cards/${cardkey}/savings-goals/transactions?fromDate=${fromDate}&toDate=${toDate}&statusCode=ACT&&rowsPerPage=${rowsPerPage}&page=${page}&search=${SearchV}`;
export const SVA_CONFIGURATION_UPDATE = (cardKey) => `api/cardholders/cards/${cardKey}/sva-configuration/ShownKudzuPlusExtendCarousal?isEnable=true`
export const COMPLETE_SAVING_GOAL =(cardkey, goalkey)=> `/api/v1/cardholders/cards/${cardkey}/savings-goals/${goalkey}/complete`
export const MOVE_FUNDS =(cardkey,goalkey)=> `/api/v1/cardholders/cards/${cardkey}/savings-goals/${goalkey}/move-funds`
 
// link smiOne card to existing kudzu account

export const VALIDATE_SMI_CARD_MOBILE= (userid)=> `/api/v1/cardholders/${userid}/link-smione-card/validate-mobile`
export const VALIDATE_SMI_CARD_FOUR_DIGITS =(userid)=>`/api/v1/cardholders/${userid}/link-smione-card/validate-card`
export const VALIDATE_SSN_OF_THE_SMI_CARD =(userid) => `/api/v1/cardholders/${userid}/link-smione-card/validate-ssn`
export const REGISTER_LINK_SMI_CARD =(userid)=> `/api/v1/cardholders/${userid}/link-smione-card`

//email update
export const EMAIL_IDENTITY = (cardKey) => `api/cardholders/cards/${cardKey}/email-identity`

//get transactions new API

export const GET_NEW_TRANSFER_ACCOUNTS =(cardkey, accountId, field) => `api/v1/users/cards/${cardkey}/${accountId}/accounts?field=${field}`

// Plad APIS

export const GET_TINK_OR_PLAID_PROVIDER  =(cardKey) => `api/cardholders/cards/${cardKey}/achaccount/provider`
export const GET_PLAID_TOKEN = (cardKey) =>  `api/cardholders/cards/${cardKey}/achaccount/plaid`

//add secondary cardholder
export const VALIDATE_SECONDARY_CARD_SSN =(cardkey) => `/api/cardholders/cards/${cardkey}/ssn/validate`
export const GET_METADATA_SCH = (cardKey) => `api/cardholders/secondary-cards/new/metadata?cardKey=${cardKey}&countryCode=USA`
export const GENERATE_OTP_SCH = (cardkey) => `api/v1/cardholders/${cardkey}/generate-otp`
export const VERIFY_OTP_SCH = (cardkey) => `api/v1/cardholders/${cardkey}/verify-otp`
export const GET_SECONDARY_CARDHOLDERS_LIST = () => `api/cardholders/cards/primary=false/addon=true`
export const GET_SECONDARY_CARDHOLDERS_LIST_WITH_PRIMARY =`api/cardholders/cards/primary=true/addon=false`
export const SCH_RESEND_OTP =(cardkey) => `api/v1/cardholders/${cardkey}/resend-otp`
export const CREATE_SCH_CARD =(cardkey) => `api/v2/cardholders/add-on?cardKey=${cardkey}`
export const GET_CARD_HOLDERS_LIST = "/api/cardholder/card/list"


// secured credit card
export const GENERATE_OTP_SECURED_CREDIT_CARD="api/secured-credit/generate-otp/secured-credit-apply?cardKey={CARD_KEY}";
export const RESEND_OTP_SECURED_CREDIT_CARD="api/secured-credit/resend-otp/secured-credit-apply?cardKey={CARD_KEY}";
export const VERIFY_OTP_SECURED_CREDIT_CARD = "api/secured-credit/verify-otp/secured-credit-apply";
export const ELIGIBILITY_CHECK_SECURED_CREDIT_CARD="api/secured-credit/cards/{CARD_KEY}/check-account-eligibility";
export const CREATE_SECURED_CREDIT_CARD="api/secured-credit/{CARD_KEY}/create-secured-credit";

//Get device token endpont
export const GET_DEVICE_TOKEN="api/cardholders/devices/token"

// Bill paymentss
export const GET_MY_BILL_PAYMENTS = (cardkey)=>`/api/cardholders/${cardkey}/billers`;
export const GET_MASTER_BILLERS = (cardKey, searchText) => `/api/cardholders/${cardKey}/masters/programs/billers?searchText=${searchText}`;
export const BILL_PAYMENTS_META_DATA =(cardKey) => `/api/cardholders/${cardKey}/billPayment/date/metadata`;
export const ADD_RPPS_BILLERS= (cardkey)=>`/api/cardholders/${cardkey}/billers/add-rpps/v2`;
export const BILLER_COUNTRIES = (cardkey) => `/api/cardholders/masters/countries?CardKey=${cardkey}`
export const BILLERE_STATES = (cardkey) => `/api/cardholders/masters/countries/states?CardKey=${cardkey}&countryCode=USA`
export const ADD_PAPER_BILLER = (cardkey) => `/api/cardholders/${cardkey}/billers/add-paper/v2`
export const GET_BILLER_DETAILS= (cardkey, svaBillerKey) => `/api/cardholders/${cardkey}/billers/details?svaBillerKey=${svaBillerKey}`
export const REMOVE_BILLERE = (cardkey)=>`/api/cardholders/${cardkey}/billers/remove`
export const MODIFY_BILLER=(cardkey)=>`/api/cardholders/${cardkey}/billers/modify-paper/v2`
export const SCHEDULED_BILLERS_LIST =(cardkey) => `/api/cardholders/${cardkey}/bill-payments/scheduled`
export const SCHEDULED_DETAILES =(cardkey, SVAPaymentKey) => `/api/cardholders/${cardkey}/bill-payments/details?SVAPaymentKey=${SVAPaymentKey}`
export const CANCEL_PAYMENT = (cardkey) => `/api/cardholder/${cardkey}/billpayment/cancel`
export const PAYMENT_HISTORY = (cardkey) => `/api/cardholders/${cardkey}/bill-payments?cardKey=${cardkey}&endDate=2026-03-23&startDate=2026-03-01&rows=20&page=1`
export const BILL_PAYMENTS_OVERVIEW =(cardkey) => `/api/cardholders/${cardkey}/billers/overview`
export const VERIFY_OTP_BILLER=(cardkey)=>`/api/v2/cardholders/mobile/verify-otp?CardKey=${cardkey}`
export const MODIFY_RPPS_BILLER =(cardkey) =>`/api/cardholders/${cardkey}/billers/modify-rpps/v2`